
  <button type="link" class="language-picker" (click)="openLocalePicker($event)" aria-describedby="languageButtonDescription">
    <img src="assets/images/cpnos/country/globe.png" alt="">{{countryName}}
  </button>
  <span id="languageButtonDescription" class="visually-hidden" >{{'changeLangLinkAriaDescription' | T}}</span>
  <cp-locale-picker-modal (onToggle)="openLocalePicker($event)" [openModal]="showLocalePicker"></cp-locale-picker-modal>
